<template>
  <div>
    <form
      class="table-filters"
      autocomplete="off"
      @submit.prevent="$emit('search')"
    >
      <v-row>
        <v-col
          v-for="(it, i) in filters"
          :key="i"
          :cols="it.type === 'select' ? '4' : '2'"
        >
          <div class="input-block input-block_white">
            <label
              class="input-block__label"
              :class="{'required': it.required || (it.requiredForSupplier && !aurus)}"
            >
              {{ it.label }}
            </label>
            <template v-if="it.type === 'date'">
              <div class="input-block input-block_white">
                <date-picker
                  v-model="it.value"
                  output="Y-m-d"
                  hide-details
                />
              </div>
            </template>
            <template v-else-if="it.type === 'select'">
              <v-select
                v-model="it.value"
                :items="it.options"
                item-text="text"
                item-value="value"
                hide-details
                clearable
                solo
              />
            </template>
            <v-text-field
              v-else
              v-model="it.value"
              hide-details
              clearable
              solo
            />
          </div>
        </v-col>
      </v-row>
      <v-btn
        outlined
        type="submit"
        large
        :disabled="!isValid"
      >
        {{ $t('common.search') }}
      </v-btn>
    </form>
    <transition
      name="layout-fade"
      mode="out-in"
    >
      <div
        v-if="noItemsFound"
        class="h4 text-center"
      >
        {{ $t('common.no_data') }}
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import DatePicker from '@/components/common/DatePicker';

export default {
  name: 'TableFilters',

  components: {
    DatePicker,
  },

  props: {
    filters: {
      type: Array,
      required: true,
    },
    noItemsFound: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState(['user', 'supplier']),
    ...mapGetters(['business']),

    isValid() {
      return Array.from(Object.values(
        this.filters.filter((it) => it.required || (it.requiredForSupplier && !this.business)),
      )).every((it) => it.value);
    },
  },
};
</script>

<style lang="scss" scoped>
  .table-filters {
    padding: 30px;
    margin-bottom: 30px;
    background: white;
    border-radius: 5px;

    &__form {
      display: flex;
      justify-content: flex-start;
      align-items: flex-end;
      margin-bottom: 20px;
    }

    &__role {
      width: 500px;
    }

    &__price-type {
      width: 196px;
    }
  }
</style>
